import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private router: Router) { }

  public isAuthenicated(): boolean {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      console.log('deu erro de login?')
      this.router.navigate(['login']);
      return false;
    }
  }
}
